import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  BooleanField,
  EditButton,
  TextInput,
  Filter,
  DateInput,
  NumberField,
} from "react-admin";

const ArticlesFilter = (props) => (
  <Filter {...props}>
    <TextInput label="Título" source="title_contains" alwaysOn />
    <DateInput label="Publicado desde" source="publishedAt_gte" />
    <DateInput label="Publicado hasta" source="publishedAt_lte" />
  </Filter>
);

const ArticlesTitle = () => <span>Artículos</span>;

export const ArticlesList = (props) => (
  <List
    filters={<ArticlesFilter />}
    title={<ArticlesTitle />}
    {...props}
    sort={{ field: "publishedAt", order: "DESC" }}
  >
    <Datagrid rowClick="edit">
      <NumberField source="id" label="ID" />
      <TextField source="title" label="Título" />
      <DateField source="publishedAt" label="Fecha de Publicación" />
      <BooleanField source="active" label="Activo" />
      <EditButton />
    </Datagrid>
  </List>
);
